const BUCKET = 'training-images';

export async function uploadTrainingImage(supabase, folder, ownerId, file) {
  if (!file?.type?.startsWith('image/')) throw new Error('invalid_image');
  if (file.size > 5 * 1024 * 1024) throw new Error('image_too_large');
  const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
  const safeExt = ['jpg', 'jpeg', 'png', 'webp'].includes(ext) ? ext : 'jpg';
  const path = `${folder}/${ownerId}/${Date.now()}.${safeExt}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    contentType: file.type,
    cacheControl: '3600',
  });
  if (error) throw error;
  return supabase.storage.from(BUCKET).getPublicUrl(path).data.publicUrl;
}
